module.exports = __webpack_public_path__ + "a2314fc9/img/rename-icon.de4e673d.svg";